import { Route, Redirect } from "react-router-dom";
import React, { Suspense, lazy, Fragment } from "react";
import Loader from "react-loaders";

import { ToastContainer } from "react-toastify";

import AuthorizeRoute from "../../components/api-authorization/AuthorizeRoute";
import ApiAuthorizationRoutes from "../../components/api-authorization/ApiAuthorizationRoutes";
import { ApplicationPaths } from "../../components/api-authorization/ApiAuthorizationConstants";

const UserPages = lazy(() => import("../../DemoPages/UserPages"));
const Applications = lazy(() => import("../../DemoPages/Applications"));
const Dashboards = lazy(() => import("../../DemoPages/Dashboards"));

const Widgets = lazy(() => import("../../DemoPages/Widgets"));
const Elements = lazy(() => import("../../DemoPages/Elements"));
const Components = lazy(() => import("../../DemoPages/Components"));
const Charts = lazy(() => import("../../DemoPages/Charts"));
const Forms = lazy(() => import("../../DemoPages/Forms"));
const Tables = lazy(() => import("../../DemoPages/Tables"));
const Landing = lazy(() => import("../../DemoPages/Landing"));
const Administrator = lazy(() => import("../../DemoPages/Administrator"));



const RegistrationForms = lazy(() =>
  import("../../DemoPages/RegistrationForms")
);
const DocumentPage = lazy(() =>
    import("../../DemoPages/DocumentPending")
);
const Renewal = lazy(() => import("../../DemoPages/Renewal"));
const MotorProposalForm = lazy(() =>
  import("../../DemoPages/MotorProposalForm")
);
const Profile = lazy(() => import("../../DemoPages/Profile"));
const CustomerProfile = lazy(() => import("../../DemoPages/CustomerProfile"));
const MotorPassengerInjury = lazy(() =>
  import("../../DemoPages/MotorPassengerInjury")
);

const AppMain = () => {
  return (
    <Fragment>
      {/* Components */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-pulse-rise" />
              </div>
              <h6 className="mt-5">
                Please wait while we load all the Components examples
                <small>
                  Because this is a demonstration we load at once all the
                  Components examples. This wouldn't happen in a real live app!
                </small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/components" component={Components} />
      </Suspense>
          <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
      {/* Forms */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-pulse-rise" />
              </div>
              <h6 className="mt-5">
                Please wait while we load all the Forms examples
                <small>
                  Because this is a demonstration we load at once all the Forms
                  examples. This wouldn't happen in a real live app!
                </small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/forms" component={Forms} />
      </Suspense>

      {/* Charts */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-rotate" />
              </div>
              <h6 className="mt-3">
                Please wait while we load all the Charts examples
                <small>
                  Because this is a demonstration we load at once all the Charts
                  examples. This wouldn't happen in a real live app!
                </small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/charts" component={Charts} />
      </Suspense>

      {/* Tables */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-pulse-rise" />
              </div>
              <h6 className="mt-5">
                Please wait while we load all the Tables examples
                <small>
                  Because this is a demonstration we load at once all the Tables
                  examples. This wouldn't happen in a real live app!
                </small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/tables" component={Tables} />
      </Suspense>

      {/* Elements */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="line-scale" />
              </div>
              <h6 className="mt-3">
                Please wait while we load all the Elements examples
                <small>
                  Because this is a demonstration we load at once all the
                  Elements examples. This wouldn't happen in a real live app!
                </small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/elements" component={Elements} />
      </Suspense>

      {/* Dashboard Widgets */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-pulse-sync" />
              </div>
              <h6 className="mt-3">
                Please wait while we load all the Dashboard Widgets examples
                <small>
                  Because this is a demonstration we load at once all the
                  Dashboard Widgets examples. This wouldn't happen in a real
                  live app!
                </small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/widgets" component={Widgets} />
      </Suspense>

      {/* Pages */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="line-scale-party" />
              </div>
              <h6 className="mt-3">
                Please wait while we load all the Pages examples
                <small>
                  Because this is a demonstration we load at once all the Pages
                  examples. This wouldn't happen in a real live app!
                </small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/Account" component={UserPages} />
          </Suspense>

    {/* Pending Document */}

    <Suspense
        fallback={
            <div className="loader-container">
                <div className="loader-container-inner">
                    <div className="text-center">
                        <Loader type="line-scale-party" />
                    </div>
                    <h6 className="mt-3">
                        Please wait while we load all the Pages examples
        <small>
                            Because this is a demonstration we load at once all the Pages
                            examples. This wouldn't happen in a real live app!
        </small>
                    </h6>
                </div>
            </div>
        }
    >
        <Route path="/Document" component={DocumentPage} />
    </Suspense>

      {/* Applications */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-pulse" />
              </div>
              <h6 className="mt-3">
                Please wait while we load all the Applications examples
                <small>
                  Because this is a demonstration we load at once all the
                  Applications examples. This wouldn't happen in a real live
                  app!
                </small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/apps" component={Applications} />
      </Suspense>

      {/* Landing */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-grid-pulse" />
              </div>
              <h6 className="mt-3">
                Processing. Please wait!
                <small>Thank you for using the LAMCO Insurance System.</small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/landing" component={Landing} />
      </Suspense>

      {/* Landing */}

      {/* Registration Forms */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-grid-pulse" />
              </div>
              <h6 className="mt-3">
                Processing. Please wait!
                <small>Thank you for using the LAMCO Insurance System.</small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/registrationforms" component={RegistrationForms} />
      </Suspense>

      {/* Registration forms */}

      {/* Renewal Forms */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-grid-pulse" />
              </div>
              <h6 className="mt-3">
                Processing. Please wait!
                <small>Thank you for using the LAMCO Insurance System.</small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/renewal" component={Renewal} />
      </Suspense>

      {/* Renewal forms */}

      {/* Motor proposal Forms */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-grid-pulse" />
              </div>
              <h6 className="mt-3">
                Processing. Please wait!
                <small>Thank you for using the LAMCO Insurance System.</small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/motorproposalform" component={MotorProposalForm} />
      </Suspense>

      {/* Motor proposal forms */}

      {/* Customer Profile Forms */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-grid-pulse" />
              </div>
              <h6 className="mt-3">
                Processing. Please wait!
                <small>Thank you for using the LAMCO Insurance System.</small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/customerprofile" component={CustomerProfile} />
      </Suspense>

      {/* Customer Profile forms */}

      {/* Profile Forms */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-grid-pulse" />
              </div>
              <h6 className="mt-3">
                Processing. Please wait!
                <small>Thank you for using the LAMCO Insurance System.</small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/profile" component={Profile} />
      </Suspense>

      {/* Profile forms */}

      {/* Motor Passenger Injury Form */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-grid-pulse" />
              </div>
              <h6 className="mt-3">
                Processing. Please wait!
                <small>Thank you for using the LAMCO Insurance System.</small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/motorpassengerinjury" component={MotorPassengerInjury} />
      </Suspense>

          {/* Motor Passenger Injury Form */}

          {/* Administrator */}

          <Suspense
              fallback={
                  <div className="loader-container">
                      <div className="loader-container-inner">
                          <div className="text-center">
                              <Loader type="ball-grid-pulse" />
                          </div>
                          <h6 className="mt-3">
                              Processing. Please wait!
                              <small>Thank you for using the LAMCO Insurance System.</small>
                          </h6>
                      </div>
                  </div>
              }
          >
              <Route path="/Administrator" component={Administrator} />
          </Suspense>

          {/* Administrator */}

      {/* Dashboards */}

      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-grid-cy" />
              </div>
              <h6 className="mt-3">
                Please wait while we load all the Dashboards examples
                <small>
                  Because this is a demonstration, we load at once all the
                  Dashboards examples. This wouldn't happen in a real live app!
                </small>
              </h6>
            </div>
          </div>
        }
      >
        <Route path="/dashboards" component={Dashboards} />
      </Suspense>

      <Route exact path="/" render={() => <Redirect to="/landing" />} />
      <ToastContainer />
    </Fragment>
  );
};

export default AppMain;
